// Shared dismiss-cooldown for auto-triggered "nag" popups (e.g. the payout
// reconnect modal) -- without this, a condition-driven popup (one that
// re-evaluates on every mount rather than a one-time "seen it" flag) pops
// right back up the moment a user closes it and opens a new tab/window,
// since plain useState resets on every fresh page load. Backed by
// localStorage (not sessionStorage) so the cooldown holds across tabs too.
const COOLDOWN_MS = 30 * 60 * 1000; // 30 minutes
const STORAGE_PREFIX = 'popupCooldown:';

export const isPopupOnCooldown = key => {
  try {
    const dismissedAt = window.localStorage.getItem(`${STORAGE_PREFIX}${key}`);
    if (!dismissedAt) return false;
    return Date.now() - Number(dismissedAt) < COOLDOWN_MS;
  } catch (e) {
    // localStorage unavailable (private browsing, etc.) -- fail open so the
    // popup still shows rather than silently never appearing.
    return false;
  }
};

export const dismissPopupWithCooldown = key => {
  try {
    window.localStorage.setItem(`${STORAGE_PREFIX}${key}`, String(Date.now()));
  } catch (e) {
    // no-op -- worst case the popup reappears sooner than 30 minutes
  }
};
